import {
  ICastingCompany,
  IRepresentativesAgency,
  IRepresentativesDivision,
  IRepresentativesRepresentation,
  IRepresentativesTalent,
} from 'shared/interfaces/IRepresentatives';

type GetRepresentativeDetailsProps = {
  talent: IRepresentativesTalent;
  agency?: IRepresentativesAgency;
  division?: IRepresentativesDivision;
  representation_type: IRepresentativesRepresentation;
  casting_private?: boolean;
  casting_company?: ICastingCompany;
};

export const getRepresentativesDetails = ({
  talent,
  agency,
  division,
  representation_type,
  casting_private,
  casting_company,
}: GetRepresentativeDetailsProps) => {
  const isRepresented = representation_type === 'agency_representation';
  const stage_name = talent?.stage_name;
  const represented_name =
    agency && agency?.full_name && isRepresented
      ? agency?.full_name
      : casting_private && casting_company?.name
        ? casting_company?.name
        : talent?.country !== 'United States'
          ? 'Freelance'
          : 'Personal Profile';
  const division_name = division && division?.name && isRepresented ? division?.name : '';
  const contact_number =
    casting_private && casting_company?.contact_number
      ? casting_company?.contact_number
      : isRepresented && agency?.contact_number
        ? agency?.contact_number
        : null;
  const country = (isRepresented && agency?.country) || null;

  return { stage_name, represented_name, division_name, contact_number, country };
};
